import { getFullTranslations } from './util';

export const esTranslationMessages = getFullTranslations('es');
